// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `delete-button .delete-button {
  display: flex;
  align-items: center;
  color: var(--motes-light-red);
  background-color: transparent;
  border: none;
}
delete-button .delete-button p {
  font-size: 13px;
  margin: 0;
  white-space: nowrap;
}
delete-button .delete-button:disabled {
  color: #898989;
}
delete-button .delete-button:not(:disabled) {
  cursor: pointer;
}
delete-button .delete-button:not(:disabled):hover:not(:disabled) {
  color: var(--motes-dark-red);
  transition: 0.2s;
}
delete-button .delete-button svg-icon {
  margin-right: var(--motes-padding);
}
delete-button .delete-button mini-loading {
  color: var(--motes-white);
  margin-left: var(--motes-padding);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/delete-button/delete-button.component.scss"],"names":[],"mappings":"AAEI;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,YAAA;AADR;AAGQ;EACI,eAAA;EACA,SAAA;EACA,mBAAA;AADZ;AAIQ;EACI,cAAA;AAFZ;AAKQ;EACI,eAAA;AAHZ;AAKY;EACI,4BAAA;EACA,gBAAA;AAHhB;AAOQ;EACI,kCAAA;AALZ;AAQQ;EACI,yBAAA;EACA,iCAAA;AANZ","sourcesContent":["delete-button {\n\n    .delete-button {\n        display: flex;\n        align-items: center;\n        color: var(--motes-light-red);\n        background-color: transparent;\n        border: none;\n\n        p {\n            font-size: 13px;\n            margin: 0;\n            white-space: nowrap;\n        }\n\n        &:disabled {\n            color: #898989;\n        }\n\n        &:not(:disabled) {\n            cursor: pointer;\n\n            &:hover:not(:disabled) {\n                color: var(--motes-dark-red);\n                transition: 0.2s;\n            }\n        }\n\n        svg-icon {\n            margin-right: var(--motes-padding);\n        }\n\n        mini-loading {\n            color: var(--motes-white);\n            margin-left: var(--motes-padding);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
